export const mockMemberNames: Record<string, string> = {
  "1": "Sho Aoki",
  "2": "Akira menai",
  "3": "野澤 哲也",
  "4": "Max Verstappen",
  "5": "Taro Yamada",
  "6": "Haruto Sato",
  "7": "Ren Takahashi",
  "8": "Yuki Tanaka",
  "9": "Kento Ito",
  "10": "Sota Watanabe",
  "11": "Riku Nakamura",
  "12": "Kai Kobayashi",
  "13": "Daiki Kato",
  "14": "Shun Yoshida",
  "15": "Yuma Yamaguchi",
  "16": "Koki Matsumoto",
};

export const mockMemberLoginIds: Record<string, string> = {
  "1": "user_aoki",
  "2": "user_menai",
  "3": "user_nozawa",
  "4": "user_verstappen",
  "5": "user_yamada",
  "6": "user_sato",
  "7": "user_takahashi",
  "8": "user_tanaka",
  "9": "user_ito",
  "10": "user_watanabe",
  "11": "user_nakamura",
  "12": "user_kobayashi",
  "13": "user_kato",
  "14": "user_yoshida",
  "15": "user_yamaguchi",
  "16": "user_matsumoto",
};
